export default {"src":"/_next/static/media/ra-aircraft-bag.7817d98b.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};